import { useQuery, useMutation } from '@apollo/client';
import {
    getProductionValueTemplatesTemplate,
    saveProductionValueTemplateTemplate,
    updateProductionValueTemplateTemplate,
    deleteProductionValueTemplateTemplate,
} from 'apollo/templates/organization';
import { ProductionValueTemplateInput } from 'models/organization';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

export const useValueTemplate = () => {
    const { showBoundary } = useDenthubErrorBoundary();

    const { data, loading: valueTemplatesLoading, refetch } = useQuery(getProductionValueTemplatesTemplate);

    const [addTemplate, { loading: addTemplateLoading }] = useMutation(saveProductionValueTemplateTemplate);
    const addValueTemplate = async (variables: ProductionValueTemplateInput) => {
        try {
            const result = await addTemplate({ variables });
            refetch();
            return result.data.saveProductionValueTemplate;
        } catch (error) {
            showBoundary(error);
        }
    };

    const [editTemplate, { loading: editTemplateLoading }] = useMutation(updateProductionValueTemplateTemplate);
    const editValueTemplate = async (variables: ProductionValueTemplateInput) => {
        try {
            const result = await editTemplate({ variables });
            refetch();
            return result.data.updateProductionValueTemplate;
        } catch (error) {
            showBoundary(error);
        }
    };

    const [deleteTemplate, { loading: deleteTemplateLoading }] = useMutation(deleteProductionValueTemplateTemplate, {
        onCompleted() {
            refetch();
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const deleteValueTemplate = async (variables: { templateId: string }) => {
        return deleteTemplate({ variables }).then((result) => result.data?.deleteProductionValueTemplate);
    };

    return {
        valueTemplates: data?.productionValueTemplates ?? [],
        valueTemplatesLoading,
        refetchValueTemplates: refetch,

        addValueTemplate,
        editValueTemplate,
        deleteValueTemplate,

        addTemplateLoading,
        editTemplateLoading,
        deleteTemplateLoading,
    };
};
